import { j as e } from "./atoms-v218.js";
import { forwardRef as p } from "react";
import { Icon as x } from "./atoms-v217.js";
import { TagSkeleton as y } from "./atoms-v2740.js";
import { Tag as j, TagContent as $, TagCloseButton as d } from "./atoms-v2741.js";
const k = p(
  ({
    ariaLabel: s,
    children: r,
    className: u,
    colorTheme: c = "light",
    disabled: o = !1,
    id: m,
    isSkeleton: f = !1,
    onClick: i,
    onRemove: n,
    size: l = "medium",
    slotProps: t,
    variant: g = "primary"
  }, b) => {
    if (f)
      return /* @__PURE__ */ e.jsx(y, {});
    const T = (() => {
      var a;
      return (a = t == null ? void 0 : t.closeButton) != null && a.ariaLabel ? t.closeButton.ariaLabel : typeof r == "string" ? `Remove ${r}` : "Remove";
    })();
    return /* @__PURE__ */ e.jsxs(
      j,
      {
        $colorTheme: c,
        $isDisabled: o,
        $size: l,
        $variant: g,
        "aria-disabled": o || void 0,
        "aria-label": s,
        className: u,
        id: m,
        ref: b,
        ...i && !o ? {
          onClick: i,
          onKeyDown: (a) => {
            a.key === "Enter" && (a.preventDefault(), a.currentTarget.click()), a.key === " " && a.preventDefault();
          },
          onKeyUp: (a) => {
            a.key === " " && (a.preventDefault(), a.currentTarget.click());
          },
          role: "button",
          tabIndex: 0
        } : {},
        children: [
          /* @__PURE__ */ e.jsx($, { className: "tag-content", children: r }),
          n && /* @__PURE__ */ e.jsx(
            d,
            {
              $size: l,
              "aria-label": T,
              className: "tag-close-button",
              "data-testid": "tag-close-button",
              onClick: n,
              children: /* @__PURE__ */ e.jsx(x, { name: "close" })
            }
          )
        ]
      }
    );
  }
);
k.displayName = "Tag";
export {
  k as Tag
};
